import { createSelector } from 'reselect'
import userRoleSelector from 'redux/selectors/user/user_role_selector'
import userRoleTypes from 'helpers/enums/userRoleTypes'
import videoStatusSelector from 'redux/selectors/interactive_video_creation/video_status_selector'
import videoStatusTypes from 'helpers/enums/interactiveVideoCreation/videoStatusTypes'

const getInteractiveVideoSettings =
	state => state.interactiveVideoCreation.settings

const getInteractiveVideoCreationMedia =
	state => state.interactiveVideoCreation.media

const settingsContainerSelector = createSelector(
	[ getInteractiveVideoSettings, userRoleSelector, videoStatusSelector, getInteractiveVideoCreationMedia ],
	(interactiveVideoSettings, userRole, videoStatus, media) => ({
		grades: interactiveVideoSettings.grades,
		subjects: interactiveVideoSettings.subjects,
		selectedGrades: interactiveVideoSettings.selectedGrades,
		selectedSubject: interactiveVideoSettings.selectedSubject,
		videoTitle: {
			value: interactiveVideoSettings.videoTitle,
			error: interactiveVideoSettings.form.videoTitle.error,
		},
		canEditSupportSettings: userRole === userRoleTypes.SUPPORT_CONTENT,
		shouldAutoselectTitle: videoStatus === videoStatusTypes.SAVING ||
			interactiveVideoSettings.isUntitled,
		credits: media.credits,
	})
)

export default settingsContainerSelector
